<template>
	<div class="">
		<Header></Header>
		<div class="ZhaokaoMore">
			<div class="ZhaokaoMoreL">
				<van-tabs v-model="active1" @click="onClicktab" title-inactive-color='#666' title-active-color='#007CCF' background="#fafafa"
				 swipeable animated :ellipsis="ellipsis">
					<van-tab title="线上课" name='0'></van-tab>
					<van-tab title="线下课" name='1'></van-tab>
				</van-tabs>
			</div>
			<div class="ZhaokaoMoreR">
				<p></p>
				<p @click="openpropTop" v-if="topOn">筛选1</p>
				<p @click="openpropBot"v-if="botOn">筛选2</p>
			</div>
		</div>
		<div>
			<div class="listSwiper">
				<van-swipe @change="swipertab" :show-indicators='indicators' :initial-swipe='index1'>
					<van-swipe-item>
						<div class="hotmain">
							<div class="hotmainbox" v-for="item in 4" :key='' @click='openDetail()'>
								<div class="horimg">
									<img height="91px" src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1578748028343&di=2b49a4ffaeea38cab2490fd644f7faa4&imgtype=0&src=http%3A%2F%2Fn.sinaimg.cn%2Fsinacn20117%2F0%2Fw1024h576%2F20190905%2F34e4-ieftthx3876424.jpg"
									 alt="">
								</div>
								<div class="hottit">
									<p>2019年（下）国考教师资格证-考前…</p>
								</div>
								<div class="hotinfo">
									<span>查看详情</span><span><img src="../assets/home/lannest.png" alt=""></span>
								</div>
							</div>
						</div>	
					</van-swipe-item>
					<!--线下课-->
					<van-swipe-item>
						<div class="hotmain">
							<div class="hotmainbox" v-for="item in 4" :key='' @click='openDetailbot()'>
								<div class="horimg">
									<img height="91px" src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1578748028343&di=2b49a4ffaeea38cab2490fd644f7faa4&imgtype=0&src=http%3A%2F%2Fn.sinaimg.cn%2Fsinacn20117%2F0%2Fw1024h576%2F20190905%2F34e4-ieftthx3876424.jpg"
									 alt="">
								</div>
								<div class="hottit">
									<p>收到我群二所大大多所群翁</p>
								</div>
								<div class="hotinfo">
									<span>查看详情</span><span><img src="../assets/home/lannest.png" alt=""></span>
								</div>
							</div>
						</div>	
					</van-swipe-item>
					
				</van-swipe>
			</div>
		</div>

		<Fotter></Fotter>
		<!--线上课筛选-->
		<div class="addreschose" v-if="topshow">
				<div class="addbox">
				 <div class="addresS">
					 <p>课程属性</p>
					 <ul>
						<li>免费课程</li>
						<li>收费课程</li>
					 </ul>
				 </div>
				  <div class="addresS">
					 <p>考试类型</p>
					 <ul>
						<li><router-link :to="{ path: '' }">教师招聘</router-link></li>
						<li>教师资格证</li>
						<li>特岗教师</li>
						<li>事业单位D类</li>
					 </ul>
				  </div>
				   <div class="addresS">
					 <p>学段</p>
					 <ul>
						<li><router-link :to="{ path: '' }">幼儿园</router-link></li>
						<li>小学</li>
						<li>初中</li>
						<li>高中</li>
					 </ul>
				  </div>
				 <div class="addresS">
					 <p>学科</p>
					 <ul>
						<li><router-link :to="{ path: '' }">语文</router-link></li>
						<li>数学</li>
						<li>英语</li>
						<li>物理</li>
						<li>化学</li>
						<li>生物</li>
						<li>地理</li>
						<li>历史</li>
						<li>美术</li>
						<li>音乐</li>
						<li>信息技术</li>
					 </ul>
				</div>
				 <div class="dbbtn">
					  <p @click="hideaddreschoseTop">取消</p>
					  <p >确定</p>
				 </div>
			</div>
		</div>	
		<!--线下课筛选-->
		<div class="addreschose" v-if="botshow">
				<div class="addbox">
				
				  <div class="addresS">
					 <p>考试类型</p>
					 <ul>
						<li><router-link :to="{ path: '' }">教师招聘</router-link></li>
						<li>教师资格证</li>
						<li>特岗教师</li>
						<li>事业单位D类</li>
					 </ul>
				  </div>
				   <div class="addresS">
					 <p>学段</p>
					 <ul>
						<li><router-link :to="{ path: '' }">幼儿园</router-link></li>
						<li>小学</li>
						<li>初中</li>
						<li>高中</li>
					 </ul>
				  </div>
				 <div class="addresS">
					 <p>地区</p>
					 <ul>
						<li><router-link :to="{ path: '' }">昆明分校</router-link></li>
						<li>昆明分校</li>
						<li>昆明分校</li>
						<li>昆明分校</li>
						<li>昆明分校</li>
						<li>昆明分校</li>
						<li>昆明分校</li>
						<li>曲靖分校</li>
					 </ul>
				</div>
				 <div class="dbbtn">
					  <p @click="hideaddreschoseBot">取消</p>
					  <p>确定</p>
				 </div>
			</div>
		</div>	
	</div>
</template>

<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	export default {
		name: 'ZhaokaoMore',
		components: {
			Header,
			Fotter
		},
		data() {
			return {
				ellipsis: false,
				indicators: false,
				active1: '0',
				index1: 0,
				topshow:false,
				botshow:false,
				topOn:true,
				botOn:false,
			}

		},
		methods: {
			onClicktab(name) {
				let names = Number(name);
				this.index1 = names;
				if(names==1){
					this.topOn=false;
					this.botOn=true;
				}else{
					this.topOn=true;
					this.botOn=false;
				}
			},
			//滑动切换
			swipertab(index1) {
				this.active1 = index1.toString();
			},
			openpropTop(){
				this.topshow=true;
			},
			hideaddreschoseTop(){
				this.topshow=false;
			},
			openpropBot(){
				this.botshow=true;
			},
			hideaddreschoseBot(){
				this.botshow=false;
			},
			
			
			//打开详情
			openDetail(){
				      this.$router.push({  
						path: '/Coursedetail',   
						name: '',  
						params: {   
							key: 'key',   
						}  
						
					})  
			},
			//线下课
			openDetailbot(){
				  this.$router.push({  
					path: '/Coursedetail_Bot',   
					name: '',  
					params: {   
						key: 'key',   
					}  
					
				})  
			}
		}
	}
</script>

<style scoped>
	.ZhaokaoMore {
		width: 95%;
		display: flex;
		height: 50px;
	}

	.ZhaokaoMoreL {
		flex: 1;
		height: 100%;
		overflow: hidden;

	}

	.ZhaokaoMoreR {
		width: 60px;
		height: 100%;
		position: relative;
	}

	.ZhaokaoMoreR p:nth-child(1) {
		width: 1px;
		height: 23px;
		position: absolute;
		top: 13px;
		left: 5px;
		background: rgb(204, 204, 204);
	}

	.ZhaokaoMoreR p:nth-child(2) {
		text-align: center;
		line-height: 50px;
		font-size: 15px;
		font-weight: 400;
		line-height: 20px;
		color: rgba(0, 124, 207, 1);
		position: absolute;
		top: 13px;
		left: 20px;
	}

	/**/

	.listSwiper {
		width: 95%;
		margin: 20px auto;
	}
	.ZhaokaoMoreR p:nth-child(3) {
		text-align: center;
		line-height: 50px;
		font-size: 15px;
		font-weight: 400;
		line-height: 20px;
		color: rgba(0, 124, 207, 1);
		position: absolute;
		top: 13px;
		left: 20px;
	}
	
</style>



// WEBPACK FOOTER //
// src/components/CourseMore.vue